module.exports = "<h1>Dashboard</h1>\r\n<div class=\"row\">\r\n    <div class=\"column col-12\">\r\n        <app-dashboarditem *ngFor=\"let key of objectKeys(dashboardItems)\" [result]=\"dashboardItems[key]\"></app-dashboarditem>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main